module.exports = __webpack_public_path__ + "img/character_4.f14bb530.svg";